<div class="row-no-margin" style="padding:10px;height:100%;">
  <div style="padding:10px;" class="row-no-margin col-md-12 ">
    <textarea style="margin-left:auto;margin-right:auto;" [value]="CurrentDetails" (change)="UpdateValue($event)" rows="6" cols="90"></textarea>
  </div>

  <div class="row-no-margin col-md-12 justify-content-center" style="align-content:center;" >
    <!--buttons-->
    <button class="blue" (click)="SaveDetail()">Save</button>&nbsp;
    <button class="blue" (click)="CloseWindow()">Close</button>
  </div>
</div>
